export default new class indexForm {
  constructor() {
    this.formNameInputSelector = '_consult-form-name-input';
    this.formPhoneInputSelector = '_consult-form-phone-input';
    this.formEmailInputSelector = '_consult-form-email-input';
    this.formPrivacyPolicyInputSelector = '_consult-form-privacypolicy-input';
    this.submitBtnSelector = '_consult-form-submit';
    this.inValidSelector = '_invalid';
    this.successSelector = '_consult-form-success';
    this.preLoaderSelector = '_consult-form-form-preloader';
    this.delay = 2000;

    $('body').on('click', `.${this.submitBtnSelector}`, (el) => {
      const { target } = el;
      const idForm = target.getAttribute('data-form-id');
      this.handler(idForm);
    });
  }

  handler(idForm) {
    const form = document.querySelector(`.${idForm}`);

    if (!form) return;

    setTimeout(() => {
      this.checkForm(form);
    }, 0);
  }

  checkForm(form) {
    if (form.matches(`.${this.inValidSelector}`)) return;

    const privacypolicy = form.querySelector(`.${this.formPrivacyPolicyInputSelector}`);
    if (privacypolicy.checked === false) {
      privacypolicy.focus();
      return;
    }

    const inputName = form.querySelector(`.${this.formNameInputSelector}`);
    const name = inputName.value;

    const inputPhone = form.querySelector(`.${this.formPhoneInputSelector}`);
    const phone = inputPhone.value;

    const inputEmail = form.querySelector(`.${this.formEmailInputSelector}`);
    const email = inputEmail.value;

    const type = 'Получить консультацию (Snippets)';

    $.request('Feedback::onSignup', {
      data: {
        name,
        phone,
        email,
        type,
      },
      complete: (res) => {
        this.showSuccess(res);
        setTimeout(() => {
          inputName.value = '';
          inputName.dispatchEvent(new Event('change', {
            bubbles: true,
          }));
          inputPhone.value = '';
          inputPhone.dispatchEvent(new Event('change', {
            bubbles: true,
          }));
          this.hideSuccess();
        }, this.delay);
      },
    });
  }

  showSuccess(res) {
    const { statusText } = res;
    if ((statusText === 'success') || (statusText === 'OK')) {
      $(`.${this.successSelector}`).addClass('show');
    }
  }

  hideSuccess() {
    $(`.${this.successSelector}`).removeClass('show');
  }
}();
